import { Step1WritingMode } from '../types/step1Writing';
import { t } from '../i18n/translate';

export interface Step1PathOption {
  mode: Step1WritingMode;
  title: string;
  description: string;
}

export interface Step1MethodStep {
  id: string;
  title: string;
  body: string;
}

/** Order shown on the path picker (Guided first). */
const STEP1_PATH_MODES: Step1WritingMode[] = ['wizard', 'typed', 'upload', 'external'];

/** Numbered steps each method walks through. Ids drive both the catalog keys and section anchors. */
const STEP1_METHOD_STEP_IDS: Record<Step1WritingMode, string[]> = {
  wizard: ['walkthrough', 'assemble', 'presentation', 'review'],
  typed: ['your-story', 'draft-checklist', 'presentation', 'review'],
  upload: ['upload', 'review-edit', 'draft-checklist', 'presentation', 'review'],
  external: ['where-kept', 'presentation', 'review'],
};

export function getStep1PathOptions(): Step1PathOption[] {
  return STEP1_PATH_MODES.map((mode) => ({
    mode,
    title: t(`step.1.method.${mode}.title`),
    description: t(`step.1.method.${mode}.description`),
  }));
}

export function getStep1MethodSteps(mode: Step1WritingMode): Step1MethodStep[] {
  return STEP1_METHOD_STEP_IDS[mode].map((id) => ({
    id,
    title: t(`step.1.method_step.${id}.title`),
    body: t(`step.1.method_step.${id}.body`),
  }));
}

export function getStep1EncryptionReminder(): string {
  return t('step.1.writing.encryption_reminder');
}

export function getStep1WritingTemplate(): string {
  return t('step.1.writing.template');
}

export function methodTitle(mode: Step1WritingMode): string {
  if (!STEP1_PATH_MODES.includes(mode)) return t('step.1.method.fallback_title');
  return t(`step.1.method.${mode}.title`);
}

export function methodStepIndex(mode: Step1WritingMode, id: string): number {
  const idx = STEP1_METHOD_STEP_IDS[mode].indexOf(id);
  return idx >= 0 ? idx : 0;
}

export function methodStepByIndex(mode: Step1WritingMode, index: number): Step1MethodStep | undefined {
  return getStep1MethodSteps(mode)[index];
}
